@if (isBrowser) {
  <nova-icon-registry />
}
  <app-shell>
    @if (translationsLoaded()) {
      @if (isOutlet) {
        <router-outlet></router-outlet>
      }
    } @else {
    <output class="app-loading" aria-live="polite">
      <div class="loading-spinner"></div>
      <div class="loading-text">Loading...</div>
    </output>
    }
  </app-shell>

  @if (isHelpFaqWidgetEnabled()) {
    <app-faq-widget></app-faq-widget>
  }

  @if (isHelpChatWidgetEnabled()) {
    <app-chat-widget></app-chat-widget>
  }
